import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useFormacionesLogic from "./hooks/useFormacionesLogic";
import FormacionesView from "./pages/FormacionesView.jsx";

export default function Formaciones() {
  const logic = useFormacionesLogic();

  return (
    <Routes>
      <Route path="/" element={<FormacionesView {...logic} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
